import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { getVisionList } from 'web-core/src/plan-benefits';
import VisionListItem from './visionListItem';

const propTypes = {
  benefits: PropTypes.arrayOf(PropTypes.object).isRequired,
  serviceTypes: PropTypes.arrayOf(PropTypes.string),
  descriptionTypes: PropTypes.arrayOf(PropTypes.string),
  coinsAsSavings: PropTypes.bool,
  translatePrefix: PropTypes.string.isRequired,
};

const defaultProps = {
  serviceTypes: null,
  descriptionTypes: null,
  coinsAsSavings: true,
};

export default class VisionList extends PureComponent {
  render() {
    const benefits = Array.isArray(this.props.serviceTypes) ?
      this.props.benefits.filter(b => this.props.serviceTypes.indexOf(b.serviceType) > -1) :
      this.props.benefits;

    const benefitValues = getVisionList({ benefits, asSavings: this.props.coinsAsSavings });
    const hasDescriptions = Array.isArray(this.props.descriptionTypes);

    return (
      <div className="detail-list">
        {benefitValues.map((benefit) => {
          const prefix = `${this.props.translatePrefix}.${benefit.serviceType}`;
          const description = hasDescriptions &&
            this.props.descriptionTypes.indexOf(benefit.serviceType) > -1 ?
              { path: `${prefix}.description` } :
              null;

          return (
            <VisionListItem
              key={benefit.serviceType}
              benefit={benefit}
              label={{ path: `${prefix}.label` }}
              description={description} />
          );
        })}
      </div>
    );
  }
}

VisionList.propTypes = propTypes;
VisionList.defaultProps = defaultProps;
